import {
  HoursPrimaryTabs,
  HoursSecondaryBusinessTabs,
  HoursSecondaryTabs,
} from '@/utils/constants/storeLocationHours/hourTabs'
import { trackHeapEvent } from '../../trackHeapEvent'

export enum HoursHeapEvents {
  saveSingle = 'location-details-save-single-hours',
  saveMultiple = 'location-details-save-multiple-hours',
}

interface ActionsHoursCommonProps {
  primaryTab: HoursPrimaryTabs
  secondaryTab: HoursSecondaryTabs | HoursSecondaryBusinessTabs
  hourType?: string
}

export interface SaveSingleHoursDataProps extends ActionsHoursCommonProps {
  status: 'Success' | 'Fail'
  storeLocationId: string
}

export interface SaveMultipleHoursDataProps extends ActionsHoursCommonProps {
  status: 'Success' | 'Fail'
  storeLocationsCount: string
  foldersCount: string
}

export interface CancelSingleHoursDataProps extends ActionsHoursCommonProps {
  storeLocationId: string
}

const primaryTabParsedNames = {
  [HoursPrimaryTabs.businessHours]: 'Business',
  [HoursPrimaryTabs.specialtyHours]: 'Specialty',
}

const secondaryTabParsedNames = {
  [HoursSecondaryTabs.regularHours]: 'Weekly',
  [HoursSecondaryTabs.holidayHours]: 'Holiday',
  [HoursSecondaryTabs.temporarilyClosed]: 'Temporarily Closed',
  [HoursSecondaryBusinessTabs.permanentlyClosed]: 'Permanently Closed',
}

export const hoursTrackingEvents = {
  saveForSingleLocation({ secondaryTab, primaryTab, ...data }: SaveSingleHoursDataProps) {
    trackHeapEvent(
      HoursHeapEvents.saveSingle,
      Object.assign(
        {
          primaryTab: primaryTabParsedNames[primaryTab],
          secondaryTab: secondaryTabParsedNames[secondaryTab],
        },
        data,
      ),
    )
  },

  saveForMultipleLocations({ secondaryTab, primaryTab, ...data }: SaveMultipleHoursDataProps) {
    trackHeapEvent(
      HoursHeapEvents.saveMultiple,
      Object.assign(
        {
          primaryTab: primaryTabParsedNames[primaryTab],
          secondaryTab: secondaryTabParsedNames[secondaryTab],
        },
        data,
      ),
    )
  },

  cancelForSingleLocation({ secondaryTab, primaryTab, ...data }: CancelSingleHoursDataProps) {
    trackHeapEvent(
      HoursHeapEvents.saveSingle,
      Object.assign(
        {
          status: 'Canceled',
          primaryTab: primaryTabParsedNames[primaryTab],
          secondaryTab: secondaryTabParsedNames[secondaryTab],
        },
        data,
      ),
    )
  },

  cancelForMultipleLocation({ secondaryTab, primaryTab }: ActionsHoursCommonProps) {
    trackHeapEvent(HoursHeapEvents.saveMultiple, {
      status: 'Canceled',
      primaryTab: primaryTabParsedNames[primaryTab],
      secondaryTab: secondaryTabParsedNames[secondaryTab],
    })
  },
}
